import { PLAYER_INITIAL_HEALTH } from "./constants";
import { Box, Container } from "./react-graphics";

type Props = {
  health: number;
  width: number;
  height: number;
  x: number;
  y: number;
};

const PADDING = 2;

const HealthMeter = ({ x, y, width, height, health }: Props) => {
  return (
    <Container x={x} y={y}>
      <Box x={0} y={0} width={width} height={height} fillColor={0x000000} />
      <Box
        x={PADDING}
        y={PADDING}
        width={(width - 2 * PADDING) * (health / PLAYER_INITIAL_HEALTH)}
        height={height - 2 * PADDING}
        fillColor={0x00ff00}
      />
    </Container>
  );
};

export default HealthMeter;
